import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { colorItems } from '@/constants/PromotionData'
import { computed } from 'vue'

// ----- props ------

export default /*#__PURE__*/_defineComponent({
  __name: 'ColorfulTabs',
  props: {
  // tab 顏色
  variant: {
    type: String,
    default: 'lake',
    validator: (value: string) => colorItems.some(item => item.variant === value)
  },
  // 外框版本
  outline: {
    type: Boolean,
    default: false
  }
},
  emits: ["click"],
  setup(__props, { emit: emits }: { emit: ({(e: 'click', event: MouseEvent): void}), expose: any, slots: any, attrs: any }) {

const props = __props



// ----- emits -----


// ----- computed -----
const btnClasses = computed(() => [
  'colorful-tab',
  `colorful-tab${props.outline ? '-outline' : ''}-${props.variant}`
])

// ----- methods -----
// 點擊事件處理
const handleClick = (event: MouseEvent) => {
  emits('click', event)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(_unref(btnClasses)),
    onClick: handleClick
  }, [
    _renderSlot(_ctx.$slots, "default")
  ], 2))
}
}

})